module.exports = __webpack_public_path__ + "static/media/icon_Calendar_Edit.59b35475.svg";